/**
 * External Dependencies
 */
import 'jquery';
import SimpleLightbox from 'simple-lightbox';

$(document).ready(() => {

  // var SimpleLightbox = window.SimpleLightbox;
  var lightbox = new SimpleLightbox({elements: '.blocks-gallery-grid a'});
  console.log(lightbox);

  addListenerMulti(window, 'load scroll resize', ()=> {
    jQuery('.wp-block-cover.parallax').each((i, e)=>{
      var box = e.getBoundingClientRect();

      if(box.top < jQuery(window).height() && box.bottom > 0){
        var calctop = box.top + box.height;
        var perc = 100 * (jQuery(window).height() + box.height - calctop) / (jQuery(window).height() + box.height);
        perc = 100 - perc;
          requestAnimationFrame(()=>{
            jQuery('.wp-block-cover__image-background', jQuery(e)).css({
            'object-position': '0 '+perc+'%',
          });

        });
      }
    });
  });

  // Load all possibilities in the dropdowns
  // populateCities(window.schedule);
  // populateVenues(window.schedule);
  // populateDates(window.schedule);

  // jQuery('.schedule select').on('change',()=>{
  //   var filter={};
  //   var city = jQuery('#cities').val();
  //   var venue = jQuery('#venues').val();
  //   var date = jQuery('#dates').val();
  //   if(date){
  //     filter.dag=date;
  //   }
  //   if(city){
  //     filter.stad=city;
  //   } else {
  //     venue=null;
  //   }
  //   if(venue){
  //     filter.bioscoop=venue;
  //   }
  //   var filtered = filterSchedule(filter);
  //   populateCities(filtered);
  //   populateVenues(filtered);
  //   populateDates(filtered);
  //   if(date){
  //     jQuery('#dates').val(date);
  //   }
  //   if(venue){
  //     jQuery('#venues').val(venue);
  //   }
  //   if(city){
  //     jQuery('#cities').val(city);
  //   }

  //   if(venue && date) {
  //     jQuery('#result').empty();
  //     for(var t in filtered) {
  //       var html='<div class="viewing">';
  //       html += filtered[t].uur;
  //       if(filtered[t].version!=='') {
  //         html+= ' ('+filtered[t].version+')';
  //       }
  //       if(filtered[t].ticketUrl!==null) {
  //         html += ' <a href="'+filtered[t].ticketUrl+'" target="_blank">Tickets</a>';
  //       }
  //       html += '</div>';
  //       jQuery('#result').append(html);
  //     }
  //     jQuery('<div class="reset">Opnieuw zoeken</div>').appendTo('#result').on('click',()=>{resetForm()});
  //     jQuery('#result').show();
  //   } else {
  //     jQuery('#result').hide();
  //   }

  // });
  populateLocSelect();
  populateBlock();


  if(navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position)=>{
      const latitude  = position.coords.latitude;
      const longitude = position.coords.longitude;
      window.loc.lat = latitude;
      window.loc.lon = longitude;
      populateBlock();
    }, ()=>{
      // helaas geen geo
    });
  }
});

function populateLocSelect(){
  if(jQuery('#viewingsblock').length>0){
    jQuery('#viewingsblock .locselect').empty();
    jQuery('#viewingsblock .locselect').append('<option value="" data-lat="" data-lon="">'+window.periscoopfilmsettings.strings.dichtbij+'</option>');
    var cities=[];
    var venues = blockData();
    for(var t in venues) {
      if(!cities.includes(venues[t].stad)){
        cities.push(venues[t].stad);
        jQuery('#viewingsblock .locselect').append('<option value="'+venues[t].stad+'" data-lat="'+venues[t].lat+'" data-lon="'+venues[t].lng+'">'+venues[t].stad+'</option>');
      }
    }
    jQuery('#viewingsblock .locselect').on('change',(e)=>{
      window.myloc.lat = $(e.currentTarget).find(':selected').data('lat');
      window.myloc.lon = $(e.currentTarget).find(':selected').data('lon');
      populateBlock();
    });


  }
}


function populateBlock(){
  if(jQuery('#viewingsblock').length>0){
    jQuery('#viewingsblock .opener').off('click').on('click',()=>{
      jQuery('#viewingsblock').toggleClass('open');
      if(jQuery('#viewingsblock').hasClass('open')){
        jQuery('#viewingsblock .opener').html('(sluiten)');
      } else {
        jQuery('#viewingsblock .opener').html('(meer)');
      }
    });
    jQuery('#viewingsblock .inner').empty();
    var venues = blockData();
    for(var t in venues) {
      var html = '<div class="bioscoop">';
      html += '<h4 class="bios"><span class="city">'+venues[t].stad+'</span><span class="venue">'+venues[t].bioscoop+'</span></h4>';
      html += '<table class="data">';
      for(var tt in venues[t].dagen){
        html += '<tr><td class="datum">'+tt+'</td><td>';
        for(var ttt in venues[t].dagen[tt]){
          html += '<div class="tijd">';
          html += '<span class="uur">'+venues[t].dagen[tt][ttt].uur+'</span>';
          html += '<span class="details">';
          if(venues[t].dagen[tt][ttt].tags){html+=''+venues[t].dagen[tt][ttt].tags+'';}
          if(venues[t].dagen[tt][ttt].version){html+=' '+venues[t].dagen[tt][ttt].version+'';}
          html += '</span>';
          if(venues[t].dagen[tt][ttt].ticketUrl!==null && venues[t].dagen[tt][ttt].ticketUrl!=='') {
            html += '<a class="accentcolor" target="_blank" href="'+venues[t].dagen[tt][ttt].ticketUrl+'">Tickets</a>';
          }
          html += '</div>';
        }
        html += '</td></tr>';
      }
      html += '</table>';
      html += '</div>';
      jQuery('#viewingsblock .inner').append(html);
    }
  }
}

function addListenerMulti(el, s, fn) {
  s.split(' ').forEach(e => el.addEventListener(e, fn, false));
}

function filterSchedule(filter) {
  var schedule = window.schedule.filter(function(item) {
    for (var key in filter) {
      if (item[key] === undefined || item[key] != filter[key])
        return false;
    }
    return true;
  });
  return schedule;

}

function orderByTime(a, b) {
  if ( a.time < b.time ){
    return -1;
  }
  if ( a.time > b.time ){
    return 1;
  }
  return 0;
}

function orderByDst(a, b) {
  if ( a.dst < b.dst ){
    return -1;
  }
  if ( a.dst > b.dst ){
    return 1;
  }
  return 0;
}


function resetForm(){
  jQuery('#result').empty().hide();
  populateCities(window.schedule);
  populateVenues(window.schedule);
  populateDates(window.schedule);
}


function getDates(schedule) {
  var data = [];
  if(typeof(schedule)!=='undefined') {
    for(var t in schedule) {
      if(!data.includes(schedule[t].dag)){
        data.push(schedule[t].dag);
      }
    }
  }
  return data;
}

function getVenues(schedule) {
  var data = [];
  if(typeof(schedule)!=='undefined') {
    for(var t in schedule) {
      if(!data.includes(schedule[t].bioscoop)){
        data.push(schedule[t].bioscoop);
      }
    }
  }
  return data;
}

function getCities(schedule) {
  var data = [];
  if(typeof(schedule)!=='undefined') {
    for(var t in schedule) {
      if(!data.includes(schedule[t].stad)){
        data.push(schedule[t].stad);
      }
    }
  }
  return data;
}

function populateVenues(schedule) {
  jQuery('#venues').empty();
  jQuery('#venues').append($('<option>', {value: '',
    text: 'Kies...',
  }));

  getVenues(schedule).forEach((e)=>{
    jQuery('#venues').append($('<option>', {
      value: e,
      text: e,
    }));
  });
}

function populateDates(schedule) {
  schedule.sort( orderByTime );
  jQuery('#dates').empty();
  jQuery('#dates').append($('<option>', {value: '',
    text: 'Kies...',
  }));
  getDates(schedule).forEach((e)=>{
    jQuery('#dates').append($('<option>', {
      value: e,
      text: e,
    }));
  });
}

function populateCities(schedule) {
  jQuery('#cities').empty();
  jQuery('#cities').append($('<option>', {value: '',
    text: 'Kies...',
  }));
  getCities(schedule).forEach((e)=>{
    jQuery('#cities').append($('<option>', {
      value: e,
      text: e,
    }));
  });
}

function blockData(){
  var venues = [];
  for(var t in window.schedule) {
    var v = window.schedule[t]
    if(typeof(venues[v.bioscoopid])=='undefined'){
      venues[v.bioscoopid] = {};
      venues[v.bioscoopid].lat = parseFloat(v.lat);
      venues[v.bioscoopid].lng = parseFloat(v.lng);
      venues[v.bioscoopid].dst = getDistanceFromLatLonInKm(parseFloat(v.lat),parseFloat(v.lng),parseFloat(getMyLat()),parseFloat(getMyLon()));
      venues[v.bioscoopid].stad = v.stad;
      venues[v.bioscoopid].bioscoop = v.bioscoop;
      venues[v.bioscoopid].dagen = [];
    }
    if(typeof(venues[v.bioscoopid].dagen[v.dag])=='undefined') {
      venues[v.bioscoopid].dagen[v.dag] = [];
    }
    var tags = v.tags!==''?v.tags:null;
    venues[v.bioscoopid].dagen[v.dag].push({'ticketUrl':v.ticketUrl,'uur':v.uur,'version':v.version,'tags':tags});
  }

  var venuesarr =[];
  for(var tt in venues){
    venuesarr.push(venues[tt]);
  }
  venuesarr.sort( orderByDst );


  return venuesarr;
}

function getMyLat() {
  if(window.myloc.lat){
    return window.myloc.lat;
  }
  return window.loc.lat;
}


function getMyLon() {
  if(window.myloc.lon){
    return window.myloc.lon;
  }
  return window.loc.lon;
}

/*

var filter = {
  address: 'England',
  name: 'Mark'
};
var users = [{
    name: 'John',
    email: 'johnson@mail.com',
    age: 25,
    address: 'USA'
  },
  {
    name: 'Tom',
    email: 'tom@mail.com',
    age: 35,
    address: 'England'
  },
  {
    name: 'Mark',
    email: 'mark@mail.com',
    age: 28,
    address: 'England'
  }
];


users= users.filter(function(item) {
  for (var key in filter) {
    if (item[key] === undefined || item[key] != filter[key])
      return false;
  }
  return true;
});

console.log(users)

*/


function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1);
  var a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180);
}
